import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { format } from 'date-fns';

import {
  SET_ON_CONTINUE,
  SET_LOADING,
  SET_SUCCESS,
} from '../../reducers/actionReducer';
import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';
import { useAuth } from '../../hooks/useAuth';
import { CHANGE_SUBSCRIPTION } from '../../mutations';
import { capitalize } from '../../utils';

export default function DowngradeToFreePlan({
  dispatchAction,
  targetPlan,
  recurringInterval,
  currentPeriodEnd,
}) {
  const { getUser } = useAuth();

  const [changeSubscription, { loading, error, called, data }] =
    useMutation(CHANGE_SUBSCRIPTION);

  useEffect(() => {
    if (changeSubscription) {
      dispatchAction({
        type: SET_ON_CONTINUE,
        payload: {
          onContinue: () =>
            changeSubscription({
              variables: {
                plan: targetPlan,
                recurringInterval,
              },
            }),
        },
      });
    }
  }, [dispatchAction, changeSubscription, targetPlan, recurringInterval]);

  useEffect(() => {
    if (loading !== undefined) {
      dispatchAction({
        type: SET_LOADING,
        payload: { loading },
      });
    }
  }, [dispatchAction, loading]);

  useEffect(() => {
    if (called && data && !error) {
      dispatchAction({
        type: SET_SUCCESS,
        payload: {
          message: 'Plan set to downgrade successfully.',
        },
      });
      getUser({ force: true });
    }
  }, [called, data, dispatchAction, error, getUser]);

  return (
    <div className="flex flex-col justify-center items center text-center space-y-4 w-full px-24">
      {loading && <LoadingSpinner message="Downgrading your plan..." />}
      {error && <ErrorText message={error.message} />}
      {!loading && !error && (
        <>
          <p>
            Downgrading to the {capitalize(targetPlan)} plan will take effect at
            the end of your billing cycle. You will stay on your current plan
            until {format(new Date(Number(currentPeriodEnd)), 'PPP')}.
          </p>
          <p>To continue downgrading your plan, click continue.</p>
        </>
      )}
    </div>
  );
}
